(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["fetch-plus-json"] = factory();
	else
		root["fetch-plus-json"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	"use strict";

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

	/**
	 * @copyright © 2015, Rick Wong. All rights reserved.
	 */

	var after = function after() {
		var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		return function (response) {
			var resolveWith = function resolveWith(value) {
				if (!options.fullResponse) {
					return value;
				}

				// When requested to return the full response, overwrite
				// the body property
				Object.defineProperty(response, "body", {
					get: function get() {
						return value;
					}
				});

				return response;
			};

			var json = response.json();

			// The return value of json() is not always Promise (?)
			// Issue: https://github.com/bitinn/node-fetch/issues/111
			if ((typeof json === "undefined" ? "undefined" : _typeof(json)) !== "object" || typeof json.then !== "function") {
				json = Promise.resolve(json);
			}

			return json.then(resolveWith).catch(function (error) {
				// JSON parse failed
				// If status is 204, assume there was no data
				if (response.status === 204) {
					return resolveWith(null);
				}

				throw error;
			});
		};
	};

	module.exports = function () {
		var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		return function (request) {
			request.options.headers["Accept"] = "application/json";
			request.options.headers["Content-Type"] = "application/json; charset=utf-8";

			if (_typeof(request.options.body) === "object") {
				request.options.body = JSON.stringify(request.options.body);
			}

			return after(options);
		};
	};

	module.exports.handler = function () {
		var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		return after(options);
	};

/***/ }
/******/ ])
});
;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mb-app-common/node_modules/fetch-plus-json/dist/index.js
// module id = 1720
// module chunks = 1